module.exports = __webpack_public_path__ + "static/media/Jejak Pustaka(1).0063c793.png";